import styled, { css } from 'styled-components';
import { palette } from '@m12s/component-library';

const zLayer = {
  lowered: 0,
  menu: 1,
  popup: 2,
  overlay: 3,
  modal: 4,
  loading: 5,
  acrossAppPopup: 6,
};

const ElevatedCard = css`
  border-radius: 0.5rem;
  border: 1px solid ${palette.Grey300};
  box-shadow: 0px 1px 1px 0px rgba(26, 32, 44, 0.08),
    0px 1px 3px 1px rgba(26, 32, 44, 0.16),
    0px -1px 4px 0px rgba(26, 32, 44, 0.05);
`;

const ElevatedCardHover = css`
  transition: box-shadow 0.2s ease;
  border-width: 2px;

  &:hover {
    box-shadow: 0px 2px 4px rgba(26, 32, 44, 0.12),
      0px 6px 12px rgba(26, 32, 44, 0.16), 0px -1px 6px rgba(26, 32, 44, 0.05);
  }
`;

const PrimaryDisplayValue = styled.span`
  color: ${palette.Grey700};
  font-size: 3rem;
  font-weight: 700;
  line-height: 3.5rem;
`;

export { zLayer, ElevatedCard, ElevatedCardHover, PrimaryDisplayValue };
